export const isContractOwner = (contract, customerIdentifier) => {
    return contract.customerIdentifier === customerIdentifier;
};
